import Link from "next/link";
import React, { useEffect } from "react";
import styled from "styled-components";
import { Contribution } from "../../data/db/types";
import { pxToRem } from "@input-output-hk/px-to-rem";
import Button from "../buttons/Button";
import LinkButton from "../link-button/LinkButton";
import Text from "../text/Text";
import { ContributionFormHeading } from "./form/ContributionFormHeading";

const ContributionSuccessElement = styled.div`
  max-width: ${pxToRem(680)};
  margin: auto;
  p > a {
    color: var(--theme-color-primary);
    text-decoration: none;
  }
`;
const ContributionSuccessCtas = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: var(--spacing-large);
  }
`;

type Props = {
  onClickCta?: () => void;
  isUpdate?: boolean;
  contribution?: Contribution;
};
const ContributionSuccess: React.FC<Props> = ({
  onClickCta,
  contribution,
  isUpdate = false
}) => {
  /**
   * Scroll to the top of the page on mount
   */
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <ContributionSuccessElement>
      <ContributionFormHeading>
        Thank you for{isUpdate ? " resubmitting " : ""} your contribution
      </ContributionFormHeading>
      <Text element="p">
        We&apos;ll be in touch shortly to let you know if your submission was
        successful. We may request some amendments to ensure all content meets
        our editorial requirements. View the progress of this contribution and
        past contributions on your{" "}
        <Link href="/profile">
          <a>Profile Page</a>
        </Link>{" "}
        {contribution?._pr?.url && (
          <>
            or view the{" "}
            <a
              href={contribution?._pr?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Pull Request on Github.
            </a>
          </>
        )}
      </Text>
      <Text element="p">
        Would you like to contribute more content? Head back to the Contribute
        page and get started.
      </Text>
      <ContributionSuccessCtas>
        <Button appearance="primary" onClick={onClickCta}>
          Submit more content
        </Button>
        <LinkButton href="/profile">Return to profile</LinkButton>
      </ContributionSuccessCtas>
    </ContributionSuccessElement>
  );
};

export default ContributionSuccess;
